import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { formatRoute } from "react-router-named-routes"
import routes from "../../routes"
import { LandingPage as LandingPageComponent } from "@swipesense/landing-page"

import Loading from "../Loading"
import PageBanner from "../PageBanner"
import "./LandingPage.scss"

const LandingPage = (props) => {
  return (
    <div className="landing-page">
      <PageBanner children={<h1>Your Facilities</h1>} />
      {props.loading ? (
        <Loading />
      ) : (
        <LandingPageComponent
          linkTag={Link}
          entities={props.facilities.map((facility) => ({
            id: facility.id,
            imageUrl: "/fallback.png",
            name: facility.name,
            departments: facility.departments,
            units: facility.units,
            link: formatRoute(routes.overview, { facilityId: facility.id }),
          }))}
        />
      )}
    </div>
  )
}

LandingPage.propTypes = {
  loading: PropTypes.bool,
  facilities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      departments: PropTypes.number,
      units: PropTypes.number,
    }).isRequired
  ),
}

export default LandingPage
